import { render, staticRenderFns } from "./Discover.vue?vue&type=template&id=050e5c8e&scoped=true"
import script from "./Discover.vue?vue&type=script&lang=js"
export * from "./Discover.vue?vue&type=script&lang=js"
import style0 from "./Discover.vue?vue&type=style&index=0&id=050e5c8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050e5c8e",
  null
  
)

export default component.exports